import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_2 = {
  style: {"width":"400px"},
  class: "d-flex justify-center"
}
const _hoisted_3 = { style: {"height":"calc(100vh - 157px)","overflow-y":"auto","border-top-left-radius":"25px","border-top-right-radius":"25px"} }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { key: 3 }
const _hoisted_8 = {
  key: 4,
  class: "text-left"
}
const _hoisted_9 = { key: 5 }
const _hoisted_10 = { key: 6 }
const _hoisted_11 = { key: 7 }
const _hoisted_12 = {
  key: 8,
  class: "text-center"
}
const _hoisted_13 = { key: 9 }
const _hoisted_14 = {
  key: 10,
  class: "text-right"
}
const _hoisted_15 = { key: 11 }
const _hoisted_16 = { class: "text-center pl-2 py-0" }
const _hoisted_17 = {
  key: 12,
  class: "text-center pl-2 py-0"
}
const _hoisted_18 = {
  key: 13,
  class: "text-center pl-2 py-0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_back = _resolveComponent("v-btn-back")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn_prev = _resolveComponent("v-btn-prev")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_AuditConnectedAcrDocuments = _resolveComponent("AuditConnectedAcrDocuments")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_Chat = _resolveComponent("Chat")!
  const _component_AuditCheckDocumentsManager = _resolveComponent("AuditCheckDocumentsManager")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { class: "d-flex justify-space-between mb-1" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "1",
                    class: "d-flex align-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_back, {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'auditReport' })))
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "11",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => [
                      _cache[27] || (_cache[27] = _createElementVNode("h2", null, "Charges supérieures à 500€ HT", -1)),
                      _createVNode(_component_v_tooltip, { location: "bottom" }, {
                        activator: _withCtx(({ props }) => [
                          _createVNode(_component_v_btn_icon, _mergeProps(props, {
                            size: "large",
                            class: "ml-2",
                            icon: "$oss-help"
                          }), null, 16)
                        ]),
                        default: _withCtx(() => [
                          _cache[26] || (_cache[26] = _createElementVNode("p", { class: "mb-0" }, " Compte d'attente 600000 et comptes 606 (sauf 6061) ou 615 - Uniquement si validées ", -1))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "1" }),
                  _createVNode(_component_v_col, { cols: "10" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(`Statut : ${_ctx.checkStatus}`), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "d-flex justify-end align-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_tooltip, {
                    location: "bottom",
                    text: "Lier un document"
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogAuditCheckDocumentsManager = true))
                      }, props, {
                        size: "x-small",
                        icon: "$oss-upload",
                        class: "mx-1"
                      }), null, 16)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps({
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openChat = !_ctx.openChat))
                      }, props, {
                        class: "btn",
                        size: "x-small",
                        icon: "$oss-chat"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _cache[28] || (_cache[28] = _createElementVNode("span", null, "Message", -1))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod || _ctx.validated || _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod
                        ,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.storeComments())),
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => _cache[29] || (_cache[29] = [
                      _createTextVNode(" Enregistrer ")
                    ])),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    disabled: 
                            _ctx.closedPeriod ||
                            _ctx.loading ||
                            _ctx.dataLoading ||
                            !_ctx.accountingPeriod ||
                            _ctx.some600000
                        ,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validateFunction())),
                    "data-cy": "CheckPurchasesOver500-valid",
                    size: "small",
                    class: "mx-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.validated ? "Invalider" : "Valider"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (_ctx.isEnableReview)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[30] || (_cache[30] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"2px","height":"25px","margin":"0 4px"} }, null, -1)),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === 1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-up",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => {
                                _ctx.reviewed = 1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _createVNode(_component_v_icon, {
                          disabled: 
                                _ctx.reviewed === -1 ||
                                !_ctx.isEnableReview ||
                                !_ctx.validated ||
                                _ctx.loading ||
                                _ctx.dataLoading
                            ,
                          size: "small",
                          icon: "$fa-thumbs-down",
                          color: "primary",
                          class: "mx-1",
                          onClick: _cache[6] || (_cache[6] = ($event: any) => {
                                _ctx.reviewed = -1;
                                _ctx.storeComments('REVIEW');
                            })
                        }, null, 8, ["disabled"]),
                        _cache[31] || (_cache[31] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1))
                      ], 64))
                    : _createCommentVNode("", true),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_prev, _mergeProps(props, {
                        disabled: !_ctx.previousControl,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToPreviousControl();
                                })
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, " Contrôle précédent : " + _toDisplayString(_ctx.previousControl && _ctx.previousControl.title
                                    ? _ctx.previousControl.title
                                    : ""), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_tooltip, { location: "bottom" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_next, _mergeProps(props, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => {
                                    _ctx.reviewed = 0;
                                    _ctx.openChat = false;
                                    _ctx.goToNextControl();
                                }),
                        disabled: !_ctx.nextControl
                      }), null, 16, ["disabled"])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, " Contrôle suivant : " + _toDisplayString(_ctx.nextControl && _ctx.nextControl.title ? _ctx.nextControl.title : ""), 1)
                    ]),
                    _: 1
                  }),
                  _cache[34] || (_cache[34] = _createElementVNode("div", { style: {"border-right":"2px solid black","width":"1px","height":"25px","margin":"0 4px"} }, null, -1)),
                  _createVNode(_component_v_menu, { "offset-y": "" }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props, {
                        class: "mx-1",
                        color: "secondary"
                      }), null, 16)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { nav: "" }, {
                        default: _withCtx(() => [
                          (_ctx.auditCheckResult && _ctx.auditCheckResult.id)
                            ? (_openBlock(), _createBlock(_component_v_list_item, {
                                key: 0,
                                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.deleteAuditCheckResult(_ctx.auditCheckResult.id))),
                                title: `Supprimer les commentaires et la validation du contrôle`
                              }, {
                                append: _withCtx(() => [
                                  _createVNode(_component_v_tooltip, {
                                    location: "bottom",
                                    text: "Chaque ligne comptable a son bouton de suppression"
                                  }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_icon, _mergeProps(props, {
                                        size: "small",
                                        icon: "$oss-trash"
                                      }), null, 16)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_v_list_item, {
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.displayActivityDialog = true))
                          }, {
                            append: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => _cache[33] || (_cache[33] = [
                                  _createTextVNode("$oss-activity")
                                ])),
                                _: 1
                              })
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => _cache[32] || (_cache[32] = [
                                  _createTextVNode("Afficher l'activité")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.loading || _ctx.dataLoading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              elevation: "0",
              style: {"background-color":"#ffffff","border-radius":"25px","margin-top":"10px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "pa-4 d-flex justify-center" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      class: "mr-3"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : (!_ctx.accountingPeriod)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 1,
                "no-gutters": "",
                class: "d-flex flex-column justify-center align-center mb-3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    class: "mr-2 mb-1",
                    size: "large"
                  }, {
                    default: _withCtx(() => _cache[35] || (_cache[35] = [
                      _createTextVNode(" $oss-warning ")
                    ])),
                    _: 1
                  }),
                  _cache[36] || (_cache[36] = _createElementVNode("h3", null, "Aucune période sélectionnée", -1))
                ]),
                _: 1
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.closedPeriod)
                  ? (_openBlock(), _createBlock(_component_v_row, {
                      key: 0,
                      "no-gutters": "",
                      class: "d-flex flex-column justify-center align-center mb-3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          class: "mr-2 mb-1",
                          size: "large"
                        }, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createTextVNode(" $oss-warning ")
                          ])),
                          _: 1
                        }),
                        _cache[38] || (_cache[38] = _createElementVNode("h3", null, "Période clôturée", -1))
                      ]),
                      _: 1
                    }))
                  : (!_ctx.accountingLines.length)
                    ? (_openBlock(), _createBlock(_component_v_row, {
                        key: 1,
                        "no-gutters": ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            class: "d-flex justify-center mb-3"
                          }, {
                            default: _withCtx(() => _cache[39] || (_cache[39] = [
                              _createElementVNode("h3", null, "Aucun achat identifié sur la période sélectionnée", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                (_ctx.accountingLines.length)
                  ? (_openBlock(), _createBlock(_component_v_card, {
                      key: 2,
                      elevation: "0",
                      style: {"background-color":"white","border-radius":"25px"},
                      class: "px-6 pb-6 pt-0 mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_title, { class: "px-0 py-2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_switch, {
                              modelValue: _ctx.hideIgnored,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.hideIgnored) = $event)),
                              label: `Cacher les achats ignorés`,
                              style: {},
                              class: "ml-2",
                              "data-cy": "CheckPurchasesOver500-achatsIgnores"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_text, { class: "pa-0" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_data_table, {
                              headers: _ctx.purchasesOver500Headers,
                              items: _ctx.alsIgnoreACRFilter,
                              "multi-sort": "",
                              loading: _ctx.loading,
                              class: "table",
                              style: {"border":"1px #ededed solid"}
                            }, {
                              "no-data": _withCtx(() => _cache[40] || (_cache[40] = [
                                _createTextVNode("Aucune anomalie")
                              ])),
                              item: _withCtx((props) => [
                                _createElementVNode("tr", null, [
                                  (props.item.date)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_4, _toDisplayString(_ctx.formatDate(props.item.date)), 1))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_5, "-")),
                                  (
                                            props.item.thirdPartyCompany &&
                                            props.item.thirdPartyCompany.name
                                        )
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_6, _toDisplayString(props.item.thirdPartyCompany.name), 1))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_7, "-")),
                                  (props.item.object && props.item.object.invoiceNumber)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(props.item.object.invoiceNumber), 1))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_9, "-")),
                                  (props.item.wording)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(props.item.wording), 1))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_11)),
                                  (
                                            props.item.accountableAccount &&
                                            props.item.accountableAccount.name
                                        )
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                                        _createElementVNode("span", {
                                          style: _normalizeStyle(_ctx.accAccColor(props.item.accountableAccount.name))
                                        }, _toDisplayString(props.item.accountableAccount.name), 5)
                                      ]))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_13)),
                                  (props.item.amountSigned)
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_14, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                props.item.amountSigned,
                                                undefined,
                                            )), 1))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_15)),
                                  _createElementVNode("td", _hoisted_16, [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: "$remove_red_eye",
                                      color: "primary",
                                      onClick: ($event: any) => (_ctx.openObject(props.item)),
                                      size: "default"
                                    }, null, 8, ["onClick"])
                                  ]),
                                  (
                                            props.item.auditCheckResults &&
                                            props.item.auditCheckResults.length &&
                                            props.item.auditCheckResults[0].status &&
                                            props.item.auditCheckResults[0].status === 'IGNORE'
                                        )
                                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, [
                                        (
                                                props.item.auditCheckResults &&
                                                props.item.auditCheckResults[0] &&
                                                props.item.auditCheckResults[0].id
                                            )
                                          ? (_openBlock(), _createBlock(_component_v_btn_trash, {
                                              key: 0,
                                              onClick: ($event: any) => (
                                                _ctx.deleteAuditCheckResult(
                                                    props.item.auditCheckResults[0].id,
                                                )
                                            ),
                                              size: "x-small"
                                            }, null, 8, ["onClick"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : (_openBlock(), _createElementBlock("td", _hoisted_18, [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$close",
                                          size: "default",
                                          color: "primary",
                                          disabled: 
                                                _ctx.disabledIgnoreBtn(
                                                    props.item.accountableAccount.name,
                                                )
                                            ,
                                          onClick: ($event: any) => (_ctx.ignoreObject(props.item))
                                        }, null, 8, ["disabled", "onClick"])
                                      ]))
                                ])
                              ]),
                              _: 1
                            }, 8, ["headers", "items", "loading"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.loading && !_ctx.dataLoading)
                  ? (_openBlock(), _createBlock(_component_AuditConnectedAcrDocuments, {
                      key: 3,
                      connectedDocuments: _ctx.connectedDocuments,
                      companyId: _ctx.companyId,
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      onUnlinkedDocument: _cache[12] || (_cache[12] = ($event: any) => (_ctx.unlinkDocument($event))),
                      onShowLinkedDocument: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showLinkedDocument($event)))
                    }, null, 8, ["connectedDocuments", "companyId", "acKey", "auditCheckResult", "accountingPeriodId"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[41] || (_cache[41] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires détaillés", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.longCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      "data-cy": "CheckPurchasesOver500-commentaireDetailles",
                                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.longCommentExpand = !_ctx.longCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.longCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "longCommentExpand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  modelValue: _ctx.longComment,
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.longComment) = $event)),
                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                  "auto-grow": "",
                                  style: {"border":"1px #ededed solid"},
                                  outlined: ""
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, {
                                      style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        _createVNode(_component_v_btn, {
                                          disabled: _ctx.closedPeriod || _ctx.validated,
                                          rounded: "",
                                          class: "btn btn_blue",
                                          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                            _createTextVNode(" Enregistrer les commentaires ")
                                          ])),
                                          _: 1
                                        }, 8, ["disabled"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[43] || (_cache[43] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Commentaires synthétiques", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      "data-cy": "CheckPurchasesOver500-commentaireSynthétiques",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.shortCommentExpand = !_ctx.shortCommentExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.shortCommentExpand)
                      ? (_openBlock(), _createBlock(_component_v_card_text, {
                          key: 0,
                          transition: "shortCommentExpand"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "px-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_textarea, {
                                  modelValue: _ctx.shortComment,
                                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.shortComment) = $event)),
                                  disabled: _ctx.closedPeriod || _ctx.validated,
                                  "auto-grow": "",
                                  style: {"border":"1px #ededed solid"},
                                  outlined: ""
                                }, null, 8, ["modelValue", "disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { style: {"padding-bottom":"0"} }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_title, {
                                      style: {"padding-top":"20px","padding-bottom":"0","padding-left":"0"},
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_spacer),
                                        (_ctx.closedPeriod || _ctx.validated)
                                          ? (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 0,
                                              disabled: "",
                                              rounded: "",
                                              class: "btn btn_blue",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[44] || (_cache[44] = [
                                                _createTextVNode(" Enregistrer les commentaires ")
                                              ])),
                                              _: 1
                                            }))
                                          : (_openBlock(), _createBlock(_component_v_btn, {
                                              key: 1,
                                              rounded: "",
                                              class: "btn btn_blue",
                                              onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_ctx.storeComments()), ["stop"])),
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                                _createTextVNode(" Enregistrer les commentaires ")
                                              ])),
                                              _: 1
                                            }))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card, {
                  elevation: "0",
                  style: {"background-color":"white","border-radius":"25px"},
                  class: "pa-6 mt-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "5",
                          class: "ma-auto"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "ma-0 pa-0" }, {
                              default: _withCtx(() => _cache[46] || (_cache[46] = [
                                _createElementVNode("h5", { class: "pl-4" }, "Grand livre c/600000 et 606 (sauf 6061) ou 615", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_col, {
                          cols: "1",
                          class: "d-flex align-center justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center"
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "align-center pa-0"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_btn_icon, {
                                      icon: 
                                            _ctx.generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        ,
                                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.generalLedgerExpand = !_ctx.generalLedgerExpand)),
                                      style: {"width":"40px"},
                                      class: "d-inline px-2"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_v_card_text, { transition: "expand" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_GeneralLedger, {
                                  ref: "generalLedger",
                                  companyId: _ctx.companyId,
                                  accountingPeriodId: _ctx.accountingPeriod.id,
                                  accountableAccountFilter: _ctx.auditItems.accountableAccounts || [],
                                  excludedAccountableAccountFilter: 
                                        _ctx.auditItems.excludedAccountableAccounts || []
                                    ,
                                  inNm1: false,
                                  onQueryDone: _ctx.onQueryDone,
                                  enableAuditedAccountableAccounts: true
                                }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "excludedAccountableAccountFilter", "onQueryDone"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, _ctx.generalLedgerExpand]
                    ])
                  ]),
                  _: 1
                }),
                (_ctx.displayActivityDialog)
                  ? (_openBlock(), _createBlock(_component_oss_dialog, {
                      key: 4,
                      modelValue: _ctx.displayActivityDialog,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                      title: "Activité",
                      "valid-title": "Fermer",
                      onValid: _cache[22] || (_cache[22] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.displayActivityDialog = false)),
                      "min-width": "60vw"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_UsersActivitiesHistory, {
                          auditCheckKey: _ctx.acKey,
                          accountingPeriodId: _ctx.accountingPeriodId
                        }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.openChat)
                  ? (_openBlock(), _createBlock(_component_Chat, {
                      key: 5,
                      auditCheckAccountingPeriodKey: _ctx.chatId,
                      chatTitle: 'Chat'
                    }, null, 8, ["auditCheckAccountingPeriodKey"]))
                  : _createCommentVNode("", true),
                (_ctx.dialogAuditCheckDocumentsManager)
                  ? (_openBlock(), _createBlock(_component_AuditCheckDocumentsManager, {
                      key: 6,
                      modelValue: _ctx.dialogAuditCheckDocumentsManager,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.dialogAuditCheckDocumentsManager) = $event)),
                      disabled: _ctx.loading || _ctx.dataLoading || !_ctx.accountingPeriod,
                      companyId: _ctx.companyId,
                      documentToDisplay: _ctx.documentToDisplay,
                      connectedDocuments: _ctx.connectedDocuments || [],
                      acKey: _ctx.acKey,
                      auditCheckResult: _ctx.auditCheckResult || {},
                      accountingPeriodId: _ctx.accountingPeriodId || undefined,
                      alreadyLinkedDoc: _ctx.alreadyLinkedDoc,
                      onUpsertedAuditCheckResult: _ctx.upsertedACR,
                      onResetDialogData: _cache[25] || (_cache[25] = ($event: any) => {
                        _ctx.alreadyLinkedDoc = false;
                        _ctx.documentToDisplay = {};
                    })
                    }, null, 8, ["modelValue", "disabled", "companyId", "documentToDisplay", "connectedDocuments", "acKey", "auditCheckResult", "accountingPeriodId", "alreadyLinkedDoc", "onUpsertedAuditCheckResult"]))
                  : _createCommentVNode("", true)
              ], 64))
      ])
    ]),
    _: 1
  }))
}